import React, { useState, useEffect } from "react";
import Footer from "../../components/CustomerPortal/Footer";
import Header from "../../components/Header";
import Sidebar from "../../components/CustomerPortal/SideBar";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import { getTokenFromLocalStorage } from "../../lib/common";
import { API_ROUTES } from "../../utils/constants";
import { useLocation } from "react-router-dom";
import { Bars } from "react-loader-spinner";

const InvoiceDetailView = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const invoiceNumber = queryParams.get("invoice-number") || "";
  const [invoiceData, setInvoiceData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let config = {
      Authorization: getTokenFromLocalStorage(),
    };

    axios({
      method: "post",
      url: API_ROUTES.INVOICE_DETAILS,
      headers: config,
      data: {
        "invoice-number": invoiceNumber,
      },
    })
      .then((response) => {
        if (response.data.data) {
          setInvoiceData(response.data.data);
        } else {
          setError("Invoice not found");
        }
      })
      .catch((error) => {
        setError("An error occurred while fetching invoice details");
        console.error("Error:", error);
      });
  }, [invoiceNumber]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!invoiceData) {
    return (
      <div class="flex justify-center items-center">
        <Bars
          height="100vh"
          width="80"
          color="#4d148c"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />{" "}
      </div>
    );
  }

  const billingInfo = invoiceData.BillingInformation || {};

  return (
    <div>
      <div>
        <Header name={{ name: "Welcome to React" }} />
      </div>
      <Sidebar />
      <div class="p-4 sm:ml-64">
        <h2 className="text-2xl pt-4 pl-4 md:pl-12 md:pr-8 pb-6">
          INVOICE DETAILS
        </h2>
        <div class="p-4 rounded-lg  ">
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div class="text-xs text-gray-700 uppercase dark:text-gray-400">
              <div className="carrer-row flex flex-col md:flex-row p-10">
                <div className="items-right rounded bg-gray-50 dark:bg-gray-800 mr-7">
                  <h6 className="text-2xl">Billing Information</h6>
                  <p className="flex text-gray-500 mt-4">
                    Invoice No: {billingInfo["Invoice No"]}
                  </p>
                  <p className="flex text-gray-500 mt-4">
                    Account No: {billingInfo["Account No"]}
                  </p>
                  <p className="flex text-gray-500 mt-4">
                    Store ID No: {billingInfo["Store ID No"]}
                  </p>
                  <p className="flex text-gray-500 mt-4">
                    FedEx Tax ID No: {billingInfo["FedEx Tax ID No"]}
                  </p>
                  <p className="flex text-gray-500 mt-4">
                    Payment Status: {billingInfo["Payment Status"]}
                  </p>
                  <p className="flex text-gray-500 mt-4">
                    Balance Due LKR:
                    <NumericFormat
                      value={billingInfo["Balance Due LKR"]}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </p>
                </div>
                <div class="items-right   rounded bg-gray-50 dark:bg-gray-800 mr-7">
                  <h6 class="text-2xl">Charge Summary</h6>
                  <p className="text-gray-500 mt-4">
                    Total Payments:
                    <NumericFormat
                      value={invoiceData.TotalPaymentsLKR}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </p>
                  <p className="text-gray-500 mt-4">
                    Total Balance Due LKR:
                    <NumericFormat
                      value={invoiceData.TotalBalanceDueLKR}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="flex space-x-1 py-8 pr-5 justify-end">
            <button
              type="button"
              class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
              Dispute Invoice
            </button>
            <button
              type="button"
              class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
              Download / Print Invoices
            </button>
            <button
              type="button"
              class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
              Pay Invoices
            </button>
          </div> */}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default InvoiceDetailView;
